import { createAction } from '@reduxjs/toolkit';

const setOperationResult = createAction<{
  name: 'releaseCfa' | 'credit' | 'buyingCfa' | 'saleCfa' | 'orderUcp';
  status: boolean;
  msg?: string;
}>('sign-result/setResult');

export { setOperationResult };
